<template>
  <div class="cloud-box">
    <div class="wrapper">
      <div class="wrapper2">
        <div class="cloud-inf">
          <div class="cloud3"><img src="/sk/skImage/云1.png" alt="" /></div>
          <div class="cloud4"><img src="/sk/skImage/云2.png" alt="" /></div>
        </div>
        <div class="cloud">
          <div class="cloud1"><img src="/sk/skImage/云1.png" alt="" /></div>
          <div class="cloud2"><img src="/sk/skImage/云2.png" alt="" /></div>
        </div>

        <div class="cloud-2">
          <div class="cloud1"><img src="/sk/skImage/云1.png" alt="" /></div>
          <div class="cloud2"><img src="/sk/skImage/云2.png" alt="" /></div>
        </div>
      </div>

      <div class="content">
        <!-- <img src="/sk/skImage/内容2.png" alt="" /> -->
      </div>
    </div>
  </div>
</template>
  
  <script>
import $ from "jquery";
import { nextTick } from "vue";
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  onBeforeUnmount,
} from "vue";
export default defineComponent({
  components: {},
  setup(props) {
    const proxyData = reactive({});
    onBeforeUnmount(() => {});
    onMounted(() => {
      nextTick(() => {});
    });
    return {
      ...toRefs(proxyData),
    };
  },
});
</script>
  
  <style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  text-align: center;
  width: 100vw;
  height: 100vh;
  background: url(/sk/skImage/背景.jpg) no-repeat;
  background-size: cover;
}

.content img {
  height: 100vh;
}
.wrapper2 {
  position: absolute;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.cloud-inf {
  position: absolute;
  width: 100vw;
  height: 100vh;
  animation: move 200s linear forwards;
}
.cloud {
  position: absolute;
  width: 100vw;
  height: 100vh;
  animation: move 200s linear infinite;
}

.cloud-2 {
  position: absolute;
  left: -1000px;
  width: 100vw;
  height: 100vh;
  animation: move 200s linear 95s infinite;
}

.cloud1 {
  /* border:1px solid #b62626; */
  position: absolute;
  top: 30%;
  left: -1200px;
}

.cloud2 {
  position: absolute;
  left: -1800px;
  /* border:1px solid #000; */
}
.cloud3 {
  /* border:1px solid #b62626; */
  position: absolute;
  top: 30%;
  left: 600px;
}

.cloud4 {
  position: absolute;
  left: 0px;
  /* border:1px solid #000; */
}

.cloud img {
  height: 70vh;
}

@-webkit-keyframes move {
  0% {
    transform: translate(-1200px, 0px);
  }
  100% {
    transform: translate(4000px, 0px);
  }
}

@keyframes move {
  0% {
    transform: translate(-1200, 0px);
  }
  100% {
    transform: translate(4000px, 0px);
  }
}
</style>
  